import React, {
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
  useReducer,
} from "react";
import {
  Archive,
  BarChart,
  Activity,
  Copy,
  GitBranch,
  Phone,
  Droplets,
  Dumbbell,
  Tag,
  Bed,
  UserMinus,
  Globe,
  Printer,
  Child,
  Baby,
  UserCheck,
  Navigation,
  Zap,
  loadingHotels,
  User,
  Filter,
  Ticket,
  Home,
  AlertCircle,
  LogIn,
  AlertTriangle,
  Info,
  ChevronLeft,
  Calendar,
  Plane,
  Hotel,
  CreditCard,
  FileText,
  Users,
  ShoppingCart,
  BarChart3,
  Settings,
  LogOut,
  Menu,
  X,
  Clock,
  MapPin,
  CheckCircle,
  MessageCircle,
  Send,
  Search,
  Loader,
  Building2,
  UserPlus,
  Shield,
  Edit,
  Trash2,
  Eye,
  Plus,
  Save,
  Wifi,
  Coffee,
  Car,
  Star,
  PlusCircle,
  ChevronRight,
  ChevronDown,
  DollarSign,
  Download,
  FileCheck,
  Mail,
  Percent,
  Package,
  Minus,
  RefreshCw,
  ChevronUp,
} from "lucide-react";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import {
  amadeusService,
  flightRequestsService,
  API_BASE_URL2,
  API_BASE_URL,
  confirmToast,
  dateIntl,
  getAirlineName,
  airports,
  formatPrixCFA,
} from "../constants/utils";


export const FlightRequestsList = ({ onRefresh }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [expandedRequest, setExpandedRequest] = useState(null);

  // États pour la gestion des voyageurs
  const [editingTravelers, setEditingTravelers] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [travelersData, setTravelersData] = useState([]);
  const [saving, setSaving] = useState(false);

  const renderTravelers = () => {
    if (!requests.travelers || requests.travelers.length === 0) {
      return (
        <div className="text-center py-4 text-gray-500">
          <Users className="w-8 h-8 mx-auto mb-2 text-gray-300" />
          <p>Aucun voyageur saisi</p>
        </div>
      );
    }

    return (
      <div className="space-y-3">
        {requests.travelers.map((traveler, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 bg-white rounded-lg border"
          >
            <div className="flex items-center space-x-3">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  traveler.type === "ADULT"
                    ? "bg-blue-100 text-blue-600"
                    : traveler.type === "CHILD"
                    ? "bg-green-100 text-green-600"
                    : "bg-pink-100 text-pink-600"
                }`}
              >
                <User className="w-4 h-4" />
              </div>
              <div>
                <div className="font-semibold">
                  {traveler.prenom} {traveler.nom}
                </div>
                <div className="text-sm text-gray-600">
                  {traveler.type === "ADULT"
                    ? "Adulte"
                    : traveler.type === "CHILD"
                    ? "Enfant"
                    : "Bébé"}
                  {traveler.numero_passeport &&
                    ` • ${traveler.numero_passeport}`}
                </div>
              </div>
            </div>
            <div className="text-right">
              {traveler.numero_siege ? (
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                  Siège {traveler.numero_siege}
                </span>
              ) : (
                <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm font-medium">
                  Siège non assigné
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };
  useEffect(() => {
    loadRequests();
  }, [filterStatus]);

  const loadRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      let data;
      if (filterStatus === "all") {
        data = await flightRequestsService.getAll();
      } else {
        data = await flightRequestsService.getByStatus(filterStatus);
      }
      setRequests(data);
    } catch (error) {
      console.error("Erreur chargement demandes:", error);
      setError("Erreur lors du chargement des demandes: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour initialiser l'édition des voyageurs
  const handleEditTravelers = useCallback((request) => {
    setCurrentRequestId(request.id);

    const totalPassengers =
      parseInt(request.searchParams?.adults || 1) +
      parseInt(request.searchParams?.children || 0) +
      parseInt(request.searchParams?.infants || 0);

    let initialTravelers = [];

    if (request.travelers && request.travelers.length > 0) {
      initialTravelers = [...request.travelers];
    } else {
      for (let i = 0; i < totalPassengers; i++) {
        let passengerType = "ADULT";
        if (i >= parseInt(request.searchParams?.adults || 1)) {
          if (
            i <
            parseInt(request.searchParams?.adults || 1) +
              parseInt(request.searchParams?.children || 0)
          ) {
            passengerType = "CHILD";
          } else {
            passengerType = "INFANT";
          }
        }

        initialTravelers.push({
          type: passengerType,
          nom: "",
          prenom: "",
          numero_passeport: "",
          numero_piece: "",
          numero_siege: "",
          passenger_index: i,
        });
      }
    }

    setTravelersData(initialTravelers);
    setEditingTravelers(true);
  }, []);

  // Fonction pour sauvegarder les voyageurs

  // Dans votre fonction handleSaveTravelers
  const handleSaveTravelers = async (travelersDataToSave = null) => {
    // Utiliser les données passées en paramètre, sinon utiliser l'état
    const dataToSave = travelersDataToSave || travelersData;

    if (!currentRequestId) return;
    console.log("DONNEES SAUVEGARDER 22", dataToSave);
    setSaving(true);
    try {
      const response = await fetch(
        `${API_BASE_URL2}/flight-requests/${currentRequestId}/travelers`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            travelers: dataToSave,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erreur lors de la sauvegarde");
      }

      const result = await response.json();
      console.log("Voyageurs sauvegardés:", result);

      toast.success("Voyageurs sauvegardés avec succès !");
      setEditingTravelers(false);
      await loadRequests();
    } catch (error) {
      console.error("Erreur sauvegarde voyageurs:", error);
      toast.error(`Erreur lors de la sauvegarde: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  // const handleSaveTravelers1 = async () => {
  //   if (!currentRequestId) return;

  //   setSaving(true);
  //   try {
  //     const invalidTravelers = travelersData.filter(
  //       (traveler) =>
  //         !traveler.nom ||
  //         !traveler.prenom ||
  //         !traveler.numero_passeport ||
  //         !traveler.numero_siege
  //     );

  //     if (invalidTravelers.length > 0) {
  //       toast.info(
  //         "Veuillez remplir tous les champs obligatoires pour chaque voyageur"
  //       );
  //       return;
  //     }

  //     const currentRequest = requests.find((r) => r.id === currentRequestId);
  //     if (!currentRequest) {
  //       toast.info("Demande non trouvée");
  //       return;
  //     }

  //     const updatedTravelers = travelersData.map((traveler, index) => {
  //       let flightInfo = {};

  //       if (currentRequest.type === "multi-flights" && currentRequest.vol) {
  //         const vol = currentRequest.vol[0];
  //         const firstItinerary = vol.itineraries?.[0];
  //         const firstSegment = firstItinerary?.segments?.[0];
  //         const lastSegment =
  //           firstItinerary?.segments?.[firstItinerary.segments.length - 1];

  //         flightInfo = {
  //           date_depart:
  //             vol.searchParams?.departureDate ||
  //             firstSegment?.departure?.at?.split("T")[0],
  //           date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
  //           heure_depart:
  //             firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) || "",
  //           heure_arrivee:
  //             lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
  //           aeroport_depart:
  //             firstSegment?.departure?.iataCode ||
  //             vol.searchParams?.originLocationCode,
  //           aeroport_arrivee:
  //             lastSegment?.arrival?.iataCode ||
  //             vol.searchParams?.destinationLocationCode,
  //           numero_vol: firstSegment?.number,
  //           compagnie: firstSegment?.carrierCode,
  //         };
  //       } else {
  //         const firstItinerary = currentRequest.itineraries?.[0];
  //         const firstSegment = firstItinerary?.segments?.[0];
  //         const lastSegment =
  //           firstItinerary?.segments?.[firstItinerary.segments.length - 1];

  //         flightInfo = {
  //           date_depart:
  //             currentRequest.searchParams?.departureDate ||
  //             firstSegment?.departure?.at?.split("T")[0],
  //           date_arrivee: currentRequest.searchParams?.departureDate,
  //           heure_depart:
  //             currentRequest.searchParams?.departureDate
  //               ?.split("T")[1]
  //               ?.substring(0, 5) || "",
  //           heure_arrivee:
  //             lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
  //           aeroport_depart:
  //             currentRequest.searchParams?.departure?.iataCode ||
  //             currentRequest.searchParams?.originLocationCode,
  //           aeroport_arrivee:
  //             currentRequest.searchParams?.arrival?.iataCode ||
  //             currentRequest.searchParams?.destinationLocationCode,
  //           numero_vol: firstSegment?.number,
  //           compagnie: firstSegment?.carrierCode,
  //         };
  //       }

  //       return {
  //         ...traveler,
  //         ...flightInfo,
  //       };
  //     });

  //     const response = await fetch(
  //       `${API_BASE_URL2}/flight-requests/${currentRequestId}`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           travelers: updatedTravelers,
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Erreur lors de la sauvegarde des voyageurs");
  //     }

  //     await response.json();

  //     toast.success("Voyageurs sauvegardés avec succès !");
  //     setEditingTravelers(false);
  //     await loadRequests();
  //   } catch (error) {
  //     console.error("Erreur sauvegarde voyageurs:", error);
  //     toast.error(`Erreur lors de la sauvegarde: ${error.message}`);
  //   } finally {
  //     setSaving(false);
  //   }
  // };


  // Fonctions pour la gestion des actions
  const handleApproveFligth = async (id) => {
    confirmToast(
        "Êtes-vous sûr de vouloir approuver cette demande ?",
        async () => {
          try {
      await flightRequestsService.approve(id);
      toast.success("Demande approuvée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
       toast.error(`Erreur: ${error.message}`);
    }
        },
        () => {
          toast.info("Action annulée.");
          return;
        }
      );
      
    
  };

  const handleRejectFligth = async (id) => {
    confirmToast(
      "Êtes-vous sûr de vouloir rejeter cette demande ?",
      async () => {
        try {
          await flightRequestsService.reject(id);
          toast.success("Demande rejetée");
          await loadRequests();
          onRefresh && onRefresh();
        } catch (error) {
          toast.error(`Erreur: ${error.message}`);
        }
      },
      () => {
        toast.info("Action annulée.");
        return;
      }
    );
  };

  const handleEmitTicket = async (id) => {
    const request = requests.find((r) => r.id === id);

    if (!request.travelers || request.travelers.length === 0) {
      toast.info(
        "Veuillez d'abord saisir les informations des voyageurs avant d'émettre le billet"
      );
      return;
    }

    const travelersWithoutSeats = request.travelers.filter(
      (t) => !t.numero_siege
    );
    if (travelersWithoutSeats.length > 0) {
      toast.info(
        "Tous les voyageurs doivent avoir un siège assigné avant d'émettre le billet"
      );
      return;
    }

    confirmToast(
      "Confirmer l'émission du billet ?",
      async () => {
        try {
      await flightRequestsService.emitTicket(id);
      toast.success("Billet émis avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    }
      },
      () => {
        toast.info("Action annulée.");
        return;
      }
    );

    
  };

  const handleDelete = async (id) => {

    confirmToast(
      "Êtes-vous sûr de vouloir supprimer cette demande ?",
      async () => {
        try {
      await flightRequestsService.delete(id);
      toast.success("Demande supprimée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      await loadRequests();

      onRefresh && onRefresh();
      // toast.error(`Erreur: ${error.message}`);
    }
      },
      () => {
        toast.info("Action annulée.");
        return;
      }
    );


    
  };
  
  const getStatusColor = (status) =>
    ({
      "En attente": "bg-yellow-100 text-yellow-700",
      Approuvée: "bg-green-100 text-green-700",
      Rejetée: "bg-red-100 text-red-700",
      "Billet émis": "bg-blue-100 text-blue-700",
    }[status] || "bg-gray-100 text-gray-700");

  const FlightSummary = ({
    request,
    getStatusColor,
    onApprove,
    onReject,
    onEditTravelers,
    onEmitTicket,
    onDownloadTicket,
    onDelete,
  }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const [selectedTicket, setSelectedTicket] = useState(null);

    // 2. Créez une fonction pour gérer l'affichage
    const handleShowTicket = (request) => {
      setSelectedTicket({
        request: request,
        billetReference: request.billetReference || `TKT-${Date.now()}`,
      });
    };

    const ElectronicTicket = ({
      request,
      billetReference,
      onClose,
      onPrint,
      onDownload,
    }) => {
      const ticketRef = useRef(null);
      const [downloading, setDownloading] = useState(false);

      // Extraire les informations de vol
      const searchParams =
        request.vol[0].searchParams || request.vol?.[0]?.searchParams;
      const itineraries = request.itineraries || request.vol?.[0]?.itineraries;
      const firstSegment = itineraries?.[0]?.segments?.[0];
      const lastSegment =
        itineraries?.[0]?.segments?.[itineraries[0].segments.length - 1];

      // Compter les types de passagers
      const adultsCount = parseInt(searchParams?.adults) || 1;
      const childrenCount = parseInt(searchParams?.children) || 0;
      const infantsCount = parseInt(searchParams?.infants) || 0;

      // Déterminer le type de chaque passager
      const getTravelerType = (index) => {
        if (index < adultsCount)
          return { type: "Adulte", icon: User, color: "blue" };
        if (index < adultsCount + childrenCount)
          return { type: "Enfant", icon: UserMinus, color: "green" };
        return { type: "Bébé", icon: Baby, color: "pink" };
      };

      // Fonction pour télécharger le billet en PDF (version simplifiée sans html2canvas)
      const handleDownloadPDF = async () => {
        setDownloading(true);
        try {
          // Version simple : ouvrir dans une nouvelle fenêtre pour impression
          const printWindow = window.open("", "_blank");
          const ticketHTML = ticketRef.current.innerHTML;

          printWindow.document.write(`
           <!DOCTYPE html>
           <html>
           <head>
             <title>Billet - ${billetReference}</title>
             <style>
               body { 
                 font-family: Arial, sans-serif; 
                 padding: 20px; 
                 max-width: 800px; 
                 margin: 0 auto;
               }
               .ticket-header { 
                 background: #2563eb; 
                 color: white; 
                 padding: 20px; 
                 border-radius: 10px 10px 0 0; 
               }
               .ticket-body { 
                 border: 1px solid #e5e7eb; 
                 padding: 20px; 
               }
               .passenger-card { 
                 border: 1px solid #e5e7eb; 
                 padding: 15px; 
                 margin: 10px 0; 
                 border-radius: 8px; 
               }
               .seat-badge { 
                 background: #2563eb; 
                 color: white; 
                 padding: 10px; 
                 border-radius: 8px; 
                 display: inline-block; 
                 font-weight: bold;
               }
               .status-confirmed {
                 background: #d1fae5;
                 color: #065f46;
                 padding: 15px;
                 border-radius: 8px;
                 margin-bottom: 20px;
               }
               @media print { 
                 body { margin: 0; } 
               }
             </style>
           </head>
           <body>
             ${ticketHTML}
           </body>
           </html>
         `);

          printWindow.document.close();

          // Option 1 : Imprimer directement
          setTimeout(() => {
            printWindow.print();
          }, 500);

          // Si vous avez html2canvas et jsPDF installés, décommentez le code ci-dessous :
          /*
          const canvas = await html2canvas(ticketRef.current, {
            scale: 2,
            logging: false,
            useCORS: true
          });
    
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
          pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          pdf.save(`billet-${billetReference}.pdf`);
          */

          onDownload && onDownload();
        } catch (error) {
          console.error("Erreur lors du téléchargement:", error);
          toast.error("Erreur lors de la génération du PDF");
        } finally {
          setDownloading(false);
        }
      };

      // Fonction pour imprimer
      const handlePrint = () => {
        window.print();
        onPrint && onPrint();
      };

      return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
            {/* En-tête avec actions */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-bold flex items-center">
                    <Plane className="mr-3" />
                    Billet Électronique
                  </h2>
                  <p className="text-blue-100 mt-2">
                    Référence: {billetReference}
                  </p>
                </div>
                <button
                  onClick={onClose}
                  className="text-white hover:bg-white/20 p-2 rounded-full transition"
                >
                  <X size={24} />
                </button>
              </div>
            </div>

            {/* Contenu du billet */}
            <div
              ref={ticketRef}
              className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]"
            >
              {/* Statut de confirmation */}
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <div className="flex items-center text-green-800">
                  <CheckCircle className="mr-2" size={24} />
                  <span className="font-semibold">
                    Réservation confirmée - Billet émis avec succès
                  </span>
                </div>
                <p className="text-sm text-green-600 mt-1">
                  Émis le {new Date().toLocaleString("fr-FR")}
                </p>
              </div>

              {/* Informations du vol */}
              <div className="bg-gray-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <Globe className="mr-2" size={20} />
                  Détails du vol
                </h3>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <div className="text-center">
                        <p className="text-3xl font-bold text-gray-900">
                          {searchParams?.originLocationCode}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          {request.vol[0]?.flightData.departure?.at
                            ? new Date(
                                request.vol[0]?.flightData.departure?.at
                              ).toLocaleTimeString("fr-FR", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : "--:--"}
                        </p>
                      </div>

                      <div className="flex-1 mx-4">
                        <div className="flex items-center">
                          <div className="flex-1 border-t-2 border-dashed border-gray-400"></div>
                          <Plane className="mx-2 text-gray-400" size={20} />
                          <div className="flex-1 border-t-2 border-dashed border-gray-400"></div>
                        </div>
                        <p className="text-xs text-center text-gray-500 mt-1">
                          {request.vol[0]?.flightData?.duration || "Direct"}
                        </p>
                      </div>

                      <div className="text-center">
                        <p className="text-3xl font-bold text-gray-900">
                          {searchParams?.destinationLocationCode}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          {request.vol[0]?.flightData?.arrival?.at
                            ? new Date(
                                request.vol[0]?.flightData?.arrival?.at
                              ).toLocaleTimeString("fr-FR", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : "--:--"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date de départ:</span>
                      <span className="font-semibold">
                        {request.vol[0]?.flightData?.departure.at
                          ? new Date(
                              request.vol[0]?.flightData?.departure.at
                            ).toLocaleDateString("fr-FR", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "N/A"}
                      </span>
                    </div>
                    {request.vol[0]?.flightData?.returnDate && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">Date de retour:</span>
                        <span className="font-semibold">
                          {new Date(
                            request.vol[0]?.flightData?.returnDate
                          ).toLocaleDateString("fr-FR", {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <span className="text-gray-600">Classe:</span>
                      <span className="font-semibold">
                        {searchParams?.travelClass || "ECONOMY"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Compagnie:</span>
                      <span className="font-semibold">
                        {getAirlineName(
                          request.vol[0]?.flightData.airline.code
                        ) || "N/A"}{" "}
                        - Vol{" "}
                        {request.vol[0]?.flightData.airline.code +
                          "" +
                          request.vol[0]?.flightData.airline.number || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Liste des passagers */}
              <div className="mb-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <Users className="mr-2" size={20} />
                  Passagers ({request.travelers?.length || 0})
                </h3>

                <div className="space-y-3">
                  {request.travelers &&
                    request.travelers.map((traveler, index) => {
                      const {
                        type,
                        icon: Icon,
                        color,
                      } = getTravelerType(index);
                      const colorClasses = {
                        blue: "bg-blue-50 border-blue-200 text-blue-700",
                        green: "bg-green-50 border-green-200 text-green-700",
                        pink: "bg-pink-50 border-pink-200 text-pink-700",
                      };

                      return (
                        <div
                          key={index}
                          className="bg-white border rounded-lg p-4 hover:shadow-md transition-shadow"
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="flex items-center mb-2">
                                <span
                                  className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${colorClasses[color]}`}
                                >
                                  <Icon size={16} className="mr-1" />
                                  {type} {index + 1}
                                </span>
                                <h4 className="ml-3 text-lg font-bold text-gray-900">
                                  {traveler.nom?.toUpperCase() || ""}{" "}
                                  {traveler.prenom || ""}
                                </h4>
                              </div>

                              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                                <div>
                                  <span className="text-gray-500">
                                    Date de naissance:
                                  </span>
                                  <p className="font-medium">
                                    {traveler.date_naissance
                                      ? new Date(
                                          traveler.date_naissance
                                        ).toLocaleDateString("fr-FR")
                                      : "N/A"}
                                  </p>
                                </div>
                                <div>
                                  <span className="text-gray-500">
                                    Passeport:
                                  </span>
                                  <p className="font-medium">
                                    {traveler.numero_passeport || "N/A"}
                                  </p>
                                </div>
                                <div>
                                  <span className="text-gray-500">
                                    Expire le:
                                  </span>
                                  <p className="font-medium">
                                    {traveler.date_expiration_passeport
                                      ? new Date(
                                          traveler.date_expiration_passeport
                                        ).toLocaleDateString("fr-FR")
                                      : "N/A"}
                                  </p>
                                </div>
                                <div>
                                  <span className="text-gray-500">
                                    Nationalité:
                                  </span>
                                  <p className="font-medium">
                                    {traveler.nationalite || "N/A"}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* Numéro de siège */}
                            <div className="ml-4">
                              <div className="bg-blue-600 text-white rounded-lg px-4 py-3 text-center">
                                <p className="text-xs uppercase">Siège</p>
                                <p className="text-2xl font-bold">
                                  {traveler.numero_siege || "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {/* Informations tarifaires */}
              <div className="bg-gray-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <CreditCard className="mr-2" size={20} />
                  Informations tarifaires
                </h3>

                <div className="space-y-2">
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Nombre de passagers:</span>
                    <span className="font-semibold">
                      {adultsCount} adulte(s), {childrenCount} enfant(s),{" "}
                      {infantsCount} bébé(s)
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Tarif total:</span>
                    <span className="font-semibold">
                      {request.montant} {request.devise || "EUR"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Taxes et frais:</span>
                    <span className="font-semibold">Inclus</span>
                  </div>
                  <div className="border-t pt-2">
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-bold">Total:</span>
                      <span className="text-2xl font-bold text-blue-600">
                        {request.montant} {request.devise || "EUR"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Informations importantes */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h4 className="font-semibold text-yellow-800 mb-2">
                  Informations importantes
                </h4>
                <ul className="text-sm text-yellow-700 space-y-1">
                  <li>
                    • Présentez-vous à l'aéroport au moins 2h avant le départ
                    (3h pour les vols internationaux)
                  </li>
                  <li>
                    • Assurez-vous que vos documents de voyage sont valides
                  </li>
                  <li>
                    • Les bagages sont soumis aux conditions de la compagnie
                    aérienne
                  </li>
                  <li>• Ce billet est non-transférable et non-remboursable</li>
                  <li>• Tous les passagers listés doivent voyager ensemble</li>
                </ul>
              </div>
            </div>

            {/* Pied de page avec actions */}
            <div className="bg-gray-100 px-6 py-4 border-t">
              <div className="flex justify-between items-center">
                <p className="text-sm text-gray-600">
                  Référence de réservation: <strong>{billetReference}</strong>
                </p>
                <div className="flex gap-3">
                  <button
                    onClick={handlePrint}
                    className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
                  >
                    <Printer className="mr-2" size={18} />
                    Imprimer
                  </button>
                  <button
                    onClick={handleDownloadPDF}
                    disabled={downloading}
                    className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  >
                    <Download className="mr-2" size={18} />
                    {downloading ? "Génération..." : "Télécharger PDF"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
    // Fonction pour obtenir le nom de la compagnie aérienne
    const getAirlineName = (code) => {
      const airlines = {
        // Europe
        AF: "Air France",
        LH: "Lufthansa",
        BA: "British Airways",
        KL: "KLM",
        SN: "Brussels Airlines",
        LX: "Swiss International Air Lines",
        IB: "Iberia",
        AZ: "Alitalia",
        TP: "TAP Air Portugal",
        AY: "Finnair",
        SK: "SAS Scandinavian Airlines",
        LO: "LOT Polish Airlines",
        OS: "Austrian Airlines",
        SU: "Aeroflot",
        TK: "Turkish Airlines",
        A3: "Aegean Airlines",
        DY: "Norwegian Air Shuttle",
        FR: "Ryanair",
        U2: "easyJet",
        VY: "Vueling",
        EW: "Eurowings",
        BT: "Air Baltic",
        JU: "Air Serbia",
        OU: "Croatia Airlines",
        KM: "Air Malta",
        FI: "Icelandair",

        // Moyen-Orient
        EK: "Emirates",
        EY: "Etihad Airways",
        QR: "Qatar Airways",
        SV: "Saudia",
        RJ: "Royal Jordanian",
        WY: "Oman Air",
        GF: "Gulf Air",
        KU: "Kuwait Airways",
        ME: "Middle East Airlines",

        // Afrique
        ET: "Ethiopian Airlines",
        MS: "EgyptAir",
        AT: "Royal Air Maroc",
        TU: "Tunisair",
        KQ: "Kenya Airways",
        SA: "South African Airways",
        MK: "Air Mauritius",
        UL: "SriLankan Airlines",
        WB: "RwandAir",
        P4: "Air Peace",
        "9U": "Air Moldova",

        // Amérique du Nord
        AA: "American Airlines",
        DL: "Delta Air Lines",
        UA: "United Airlines",
        AC: "Air Canada",
        WN: "Southwest Airlines",
        B6: "JetBlue Airways",
        AS: "Alaska Airlines",
        WS: "WestJet",
        F9: "Frontier Airlines",

        // Amérique du Sud
        LA: "LATAM Airlines",
        AV: "Avianca",
        CM: "Copa Airlines",
        AR: "Aerolíneas Argentinas",
        G3: "Gol Transportes Aéreos",
        AD: "Azul Brazilian Airlines",
        JJ: "LATAM Brasil",

        // Asie
        SQ: "Singapore Airlines",
        CX: "Cathay Pacific",
        NH: "ANA All Nippon Airways",
        JL: "Japan Airlines",
        KE: "Korean Air",
        OZ: "Asiana Airlines",
        CI: "China Airlines",
        BR: "EVA Air",
        TG: "Thai Airways",
        MH: "Malaysia Airlines",
        GA: "Garuda Indonesia",
        PR: "Philippine Airlines",
        VN: "Vietnam Airlines",
        CZ: "China Southern Airlines",
        MU: "China Eastern Airlines",
        CA: "Air China",
        HU: "Hainan Airlines",
        FM: "Shanghai Airlines",
        "3U": "Sichuan Airlines",
        "9C": "Spring Airlines",

        // Océanie
        QF: "Qantas",
        VA: "Virgin Australia",
        NZ: "Air New Zealand",
        FJ: "Fiji Airways",

        // Compagnies low-cost
        NK: "Spirit Airlines",
        SY: "Sun Country Airlines",
        G4: "Allegiant Air",
        Y4: "Volaris",
        Y9: "Air Arabia",
        FD: "Thai AirAsia",
        AK: "AirAsia",
        D7: "AirAsia X",
        TR: "Scoot",
        Z2: "Philippines AirAsia",

        // Compagnies cargo
        "5Y": "Atlas Air",
        K4: "Kalitta Air",
        W8: "Cargojet Airways",

        // Régionales
        YX: "Republic Airways",
        OO: "SkyWest Airlines",
        "9E": "Endeavor Air",
        MQ: "Envoy Air",
        OH: "PSA Airlines",

        // Autres
        "2J": 'Air Burkina',
        AI: "Air India",
        PK: "Pakistan International Airlines",
        BG: "Biman Bangladesh Airlines",
        UL: "SriLankan Airlines",
        UL: "SriLankan Airlines",
        BI: "Royal Brunei Airlines",
        OM: "MIAT Mongolian Airlines",
        RGN: "Regional Express",
        J2: "Azerbaijan Airlines",
        KC: "Air Astana",
        HY: "Uzbekistan Airways",
        FV: "Rossiya Airlines",
        S7: "S7 Airlines",
        U6: "Ural Airlines",
        "5N": "Nordavia",
        D2: "Severstal Air Company",
        N4: "Nordwind Airlines",
        ZF: "Azur Air",
        Y7: "NordStar Airlines",
        DP: "Pobeda",
        "6W": "Saratov Airlines",
        B2: "Belavia",
        "7J": "Tajik Air",
        NQ: "Air Japan",
        JW: "Vanilla Air",
        MM: "Peach Aviation",
        GK: "Jetstar Japan",
        BC: "Skymark Airlines",
        LJ: "Jin Air",
        ZE: "Eastar Jet",
        TW: "Tway Air",
        BX: "Air Busan",
        RS: "Air Seoul",
        VZ: "Thai Vietjet Air",
        SL: "Thai Lion Air",
        DD: "Nok Air",
        XJ: "Thai AirAsia X",
        Z8: "Amaszonas",
        "8L": "Lucky Air",
        GJ: "Loong Air",
        DR: "Ruili Airlines",
        A6: "Air Travel",
        GT: "Air Guilin",
        QW: "Qingdao Airlines",
        CN: "West Air",
        PN: "China West Air",
        RY: "Jiangxi Air",
        VD: "Henan Airlines",
        G5: "China Express Air",
        "9H": "Air Changan",
        NS: "Hebei Airlines",
        KN: "China United",
        JD: "Capital Airlines",
        DZ: "Donghai Airlines",
        Y8: "Yangtze River Express",
        OQ: "Chongqing Airlines",
        GX: "GX Airlines",
        AQ: "9 Air",
        EU: "Chengdu Airlines",
        UQ: "Urumqi Air",
        QW: "Qingdao Airlines",
        RY: "Jiangxi Air",
        VD: "Henan Airlines",
      };

      return airlines[code] || code;
    };

    

    // Fonction pour formater la durée
    const formatDuration = (duration) => {
      if (!duration) return "N/A";
      const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
      const hours = match[1] ? parseInt(match[1]) : 0;
      const minutes = match[2] ? parseInt(match[2]) : 0;

      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}min`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${minutes}min`;
      }
    };

    // Déterminer le type de vol
    const getFlightType = () => {
      if (request.type === "multi-flights") {
        return "Multi-destinations";
      } else if (request.searchParams?.tripType === "round-trip") {
        return "Aller-retour";
      } else {
        return "Aller simple";
      }
    };

    // Fonction pour obtenir les informations d'escale
    const getStopoverInfo = (itinerary) => {
      if (!itinerary.segments || itinerary.segments.length <= 1) {
        return { stops: 0, airports: [] };
      }

      const stopoverAirports = [];
      for (let i = 0; i < itinerary.segments.length - 1; i++) {
        const currentSegment = itinerary.segments[i];
        const nextSegment = itinerary.segments[i + 1];

        if (currentSegment.arrival && nextSegment.departure) {
          stopoverAirports.push({
            airport: currentSegment.arrival.iataCode,
            duration: "Variable",
          });
        }
      }

      return {
        stops: itinerary.segments.length - 1,
        airports: stopoverAirports,
      };
    };

    // Fonction pour obtenir les informations du premier vol

    const getFlightInfo = () => {
      if (request.vol > 0) {
        // Cas multi-vols
        console.log("DONNEES A EXTRAIRE", request);
        const data = request.vol[0].flightData;
        if (data) {
          return {
            flightNumber: `${data.airline.code}${data.airline.number}`,
            airline: data.airline.code,
            departure: data.departure?.at.iataCode,
            destination: data.arrival?.iataCode,
            departureDate: data.departure?.at,
            departureTime: data.departure?.at,
          };
        }
      }
      // Fallback aux paramètres de recherche
      return {
        flightNumber: "N/A",
        airline: "N/A",
        departure: request.searchParams?.originLocationCode || "N/A",
        destination: request.searchParams?.destinationLocationCode || "N/A",
        departureDate: request.searchParams?.departureDate
          ? new Date(request.searchParams.departureDate)
          : null,
        departureTime: "N/A",
      };
    };

    const getFirstFlightInfo = () => {
      try {
        if (request.vol && request.vol.length > 0) {
          // Cas multi-vols
          console.log("DONNEES DE REQUETE", request);
          totalTravelers =
            request.searchParams.adults +
            request.searchParams.children +
            request.searchParams.infants;
          console.log("DONNEES DE CALCULEE", request.searchParams);
          const firstVol = request.vol[0];
          const data = firstVol.flightData;

          if (data) {
            // Gestion sécurisée des dates
            let departureDate = null;
            let departureTime = "N/A";

            if (data.departure?.at) {
              try {
                const dateObj = new Date(data.departure.at);
                if (!isNaN(dateObj.getTime())) {
                  departureDate = dateObj;
                  departureTime = dateObj.toLocaleTimeString("fr-FR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                }
              } catch (dateError) {
                console.warn("Erreur de format de date:", dateError);
              }
            }

            // Gestion sécurisée des autres champs
            const flightNumber =
              data.airline?.code && data.airline?.number
                ? `${data.airline.code}${data.airline.number}`
                : "N/A";

            const airline = data.airline?.code
              ? getAirlineName(data.airline.code)
              : "N/A";

            const departure = data.departure?.iataCode || "N/A";
            const destination = data.arrival?.iataCode || "N/A";

            return {
              flightNumber,
              airline,
              departure,
              destination,
              departureDate,
              departureTime,
            };
          }
        }

        // Fallback aux paramètres de recherche avec gestion d'erreur
        let fallbackDepartureDate = null;
        let fallbackDepartureTime = "N/A";

        if (request.searchParams?.departureDate) {
          try {
            const dateObj = new Date(request.searchParams.departureDate);
            if (!isNaN(dateObj.getTime())) {
              fallbackDepartureDate = dateObj;
              fallbackDepartureTime = dateObj.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              });
            }
          } catch (dateError) {
            console.warn("Erreur de format de date (fallback):", dateError);
          }
        }

        return {
          flightNumber: "N/A",
          airline: "N/A",
          departure: request.searchParams?.originLocationCode || "N/A",
          destination: request.searchParams?.destinationLocationCode || "N/A",
          departureDate: fallbackDepartureDate,
          departureTime: fallbackDepartureTime,
        };
      } catch (error) {
        console.error("Erreur dans getFirstFlightInfo:", error);
        // Retourner des valeurs par défaut en cas d'erreur critique
        return {
          flightNumber: "N/A",
          airline: "N/A",
          departure: "N/A",
          destination: "N/A",
          departureDate: null,
          departureTime: "N/A",
        };
      }
    };

    const adults = parseInt(request.searchParams?.adults || 0);
    const children = parseInt(request.searchParams?.children || 0);
    const infants = parseInt(request.searchParams?.infants || 0);
    const totalTravelers = adults + children + infants;
    const calculertotalTravelers = () => {
      console.log("DONNEES DE CALCUL", request);
      const adults = parseInt(request.vol[0].searchParams?.adults || 0);
      const children = parseInt(request.vol[0].searchParams?.children || 0);
      const infants = parseInt(request.vol[0].searchParams?.infants || 0);
      const totalTravelers = adults + children + infants;

      return totalTravelers;
    };

    const isMultiFlight = request.type === "multi-flights";
    const flightCount = isMultiFlight && request.vol ? request.vol.length : 1;
    const flightType = getFlightType();
    const firstFlightInfo = getFirstFlightInfo();
    const RecapFlightInfo = getFlightInfo();

    // Rendu détaillé des segments de vol
    const renderFlightSegments = (segments, flightIndex = 0) => {
      return segments.map((segment, segmentIndex) => {
        const stopoverInfo =
          segmentIndex < segments.length - 1
            ? getStopoverInfo({ segments: segments.slice(segmentIndex) })
            : null;

        return (
          <div key={segmentIndex} className="mb-6">
            {/* Segment principal */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                {/* Informations du vol */}
                <div className="lg:col-span-2">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h4 className="font-bold text-lg text-gray-900">
                        Vol {segment.carrierCode}
                        {segment.number}
                      </h4>
                      <p className="text-gray-600">
                        {getAirlineName(segment.carrierCode)}
                      </p>
                    </div>
                    <div
                      className={`px-3 py-1 rounded-full text-sm font-medium ${
                        request.searchParams?.travelClass === "BUSINESS"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-blue-100 text-blue-700"
                      }`}
                    >
                      {request.searchParams?.travelClass === "BUSINESS"
                        ? "Affaires"
                        : "Économique"}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Départ</p>
                      <p className="font-semibold text-lg">
                        {segment.departure?.iataCode}
                      </p>
                      <p className="text-sm text-gray-600">
                        {segment.departure?.at
                          ? new Date(segment.departure.at).toLocaleDateString(
                              "fr-FR"
                            )
                          : "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Arrivée</p>
                      <p className="font-semibold text-lg">
                        {segment.arrival?.iataCode}
                      </p>
                      <p className="text-sm text-gray-600">
                        {segment.arrival?.at
                          ? new Date(segment.arrival.at).toLocaleDateString(
                              "fr-FR"
                            )
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Horaires */}
                <div className="border-l pl-6">
                  <p className="text-sm text-gray-500 mb-2">Horaires</p>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="font-medium">Départ:</span>
                      <span className="font-bold">
                        {segment.departure?.at
                          ? new Date(segment.departure.at).toLocaleTimeString(
                              "fr-FR",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium">Arrivée:</span>
                      <span className="font-bold">
                        {segment.arrival?.at
                          ? new Date(segment.arrival.at).toLocaleTimeString(
                              "fr-FR",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between border-t pt-2">
                      <span className="font-medium">Durée:</span>
                      <span className="font-bold text-blue-600">
                        {formatDuration(segment.duration)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Informations supplémentaires */}
                <div className="border-l pl-6">
                  <p className="text-sm text-gray-500 mb-2">Détails</p>
                  <div className="space-y-2">
                    <div className="flex items-center text-sm">
                      <Plane className="w-4 h-4 mr-2 text-gray-400" />
                      <span>Avion: {segment.aircraft?.code || "Standard"}</span>
                    </div>
                    <div className="flex items-center text-sm">
                      <Clock className="w-4 h-4 mr-2 text-gray-400" />
                      <span>Durée: {formatDuration(segment.duration)}</span>
                    </div>
                    {segment.stopover && (
                      <div className="flex items-center text-sm text-amber-600">
                        <Navigation className="w-4 h-4 mr-2" />
                        <span>Avec escale</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Information d'escale */}
            {stopoverInfo && stopoverInfo.stops > 0 && (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-2 mb-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <Navigation className="w-5 h-5 text-amber-600 mr-2" />
                    <span className="font-semibold text-amber-800">
                      Escale à {stopoverInfo.airports[0]?.airport || "N/A"}
                    </span>
                  </div>
                  <span className="text-sm text-amber-700">
                    {stopoverInfo.stops} escale
                    {stopoverInfo.stops > 1 ? "s" : ""}
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      });
    };

    // Rendu des détails du vol principal
    const renderFlightDetails = () => {
      if (request.vol) {
        // Créer un Set pour tracker les vols déjà affichés
        const displayedFlights = new Set();

        return request.vol
          .map((vol, index) => {
            // Créer une clé unique pour identifier le vol (origine + destination + date)
            const flightKey = `${vol.searchParams?.originLocationCode}-${vol.searchParams?.destinationLocationCode}-${vol.searchParams?.departureDate}`;

            // Si ce vol a déjà été affiché, ne pas le réafficher
            if (displayedFlights.has(flightKey)) {
              return null;
            }

            // Marquer ce vol comme affiché
            displayedFlights.add(flightKey);

            // Compter le nombre de fois que ce vol apparaît (pour afficher le nombre de passagers)
            const sameFlights = request.vol.filter(
              (v) =>
                `${v.searchParams?.originLocationCode}-${v.searchParams?.destinationLocationCode}-${v.searchParams?.departureDate}` ===
                flightKey
            );

            const passengerCount = sameFlights.length;

            return (
              <div key={index} className="mb-8">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                  <h4 className="font-bold text-lg text-blue-900 flex items-center">
                    <Plane className="w-5 h-5 mr-2" />
                    Vol {index + 1} - {vol.searchParams?.originLocationCode} →{" "}
                    {vol.searchParams?.destinationLocationCode}
                    {passengerCount > 1 && (
                      <span className="ml-2 bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">
                        {passengerCount} passager{passengerCount > 1 ? "s" : ""}
                      </span>
                    )}
                  </h4>
                  <p className="text-blue-700 text-sm">
                    {vol.searchParams?.departureDate
                      ? `Départ: ${new Date(
                          vol.searchParams.departureDate
                        ).toLocaleDateString("fr-FR", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}`
                      : "N/A"}
                  </p>
                  {vol.flightTypeLabel && (
                    <p className="text-blue-600 text-sm font-medium mt-1">
                      Type: {vol.flightTypeLabel}
                    </p>
                  )}
                </div>

                {vol.itineraries?.map((itinerary, itinIndex) => (
                  <div key={itinIndex}>
                    {renderFlightSegments(itinerary.segments, index)}
                  </div>
                ))}
              </div>
            );
          })
          .filter(Boolean); // Filtrer les null
      } else {
        // Vol simple
        return request.itineraries?.map((itinerary, index) => (
          <div key={index}>
            {itinerary.segments && renderFlightSegments(itinerary.segments)}
          </div>
        ));
      }
    };

    // Rendu des voyageurs
    const renderTravelers = () => {
      // Extraction des données depuis searchParams
      const adults = parseInt(request.searchParams?.adults || 0);
      const children = parseInt(request.searchParams?.children || 0);
      const infants = parseInt(request.searchParams?.infants || 0);
      const totalTravelers = adults + children + infants;

      // Si des voyageurs détaillés existent, les afficher
      if (request.travelers && request.travelers.length > 0) {
        return (
          <div className="space-y-4">
            {request.travelers.map((traveler, index) => (
              <div
                key={index}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center ${
                        traveler.type === "ADULT"
                          ? "bg-blue-100 text-blue-600"
                          : traveler.type === "CHILD"
                          ? "bg-green-100 text-green-600"
                          : "bg-pink-100 text-pink-600"
                      }`}
                    >
                      <User className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="font-semibold text-lg">
                        {traveler.prenom} {traveler.nom?.toUpperCase()}
                      </div>
                      <div className="text-sm text-gray-600">
                        {traveler.type === "ADULT"
                          ? "Adulte"
                          : traveler.type === "CHILD"
                          ? "Enfant"
                          : "Bébé"}
                        {traveler.dateNaissance &&
                          ` • ${new Date(
                            traveler.dateNaissance
                          ).toLocaleDateString("fr-FR")}`}
                      </div>
                      {traveler.numero_passeport && (
                        <div className="text-sm text-gray-500 mt-1">
                          Passeport: {traveler.numero_passeport}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    {traveler.numero_siege ? (
                      <span className="bg-green-100 text-green-700 px-3 py-2 rounded-full text-sm font-medium">
                        Siège {traveler.numero_siege}
                      </span>
                    ) : (
                      <span className="bg-yellow-100 text-yellow-700 px-3 py-2 rounded-full text-sm font-medium">
                        Siège non assigné
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      }

      // Si aucun voyageur détaillé mais des counts dans searchParams
      if (request.vol[0].searchParams.adults > 0) {
        return (
          <div className="space-y-6">
            {/* En-tête */}
            <div className="bg-blue-50 rounded-lg border border-blue-200 p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <Users className="w-5 h-5 text-blue-600 mr-2" />
                  <h5 className="font-semibold text-blue-800">
                    Récapitulatif des voyageurs
                  </h5>
                </div>
                <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                  {request.vol[0].searchParams.adults +
                    request.vol[0].searchParams.children +
                    request.vol[0].searchParams.infants}{" "}
                  + voyageur
                  {request.vol[0].searchParams.adults +
                    request.vol[0].searchParams.children +
                    request.vol[0].searchParams.infants >
                  1
                    ? "s"
                    : ""}
                </div>
              </div>
            </div>

            {/* Détails par catégorie */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {request.vol[0].searchParams.adults > 0 && (
                <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <User className="w-6 h-6 text-blue-600" />
                  </div>
                  <div className="text-2xl font-bold text-blue-600">
                    {request.vol[0].searchParams.adults}
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Adulte(s)
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    12 ans et plus
                  </div>
                </div>
              )}

              {request.vol[0].searchParams.children > 0 && (
                <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <User className="w-6 h-6 text-green-600" />
                  </div>
                  <div className="text-2xl font-bold text-green-600">
                    {request.vol[0].searchParams.children}
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Enfant(s)
                  </div>
                  <div className="text-xs text-gray-500 mt-1">2-11 ans</div>
                </div>
              )}

              {request.vol[0].searchParams.infants > 0 && (
                <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                  <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <User className="w-6 h-6 text-pink-600" />
                  </div>
                  <div className="text-2xl font-bold text-pink-600">
                    {request.vol[0].searchParams.infants}
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Bébé(s)
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Moins de 2 ans
                  </div>
                </div>
              )}
            </div>

            {/* Message d'information */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <div className="flex items-start">
                <Info className="w-5 h-5 text-amber-600 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-amber-700 text-sm">
                    <span className="font-medium">
                      Informations détaillées manquantes :
                    </span>
                    <br />
                    Les noms et prénoms des voyageurs n'ont pas encore été
                    saisis. Utilisez le bouton "Saisir voyageurs" pour compléter
                    ces informations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      }

      // Si aucun voyageur du tout
      return (
        <div className="text-center py-8 text-gray-500">
          <Users className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="text-lg">Aucun voyageur saisi</p>
          <p className="text-sm mt-1">
            Utilisez le bouton "Saisir voyageurs" pour ajouter des passagers
          </p>
        </div>
      );
    };

    return (
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
        {/* En-tête du récapitulatif */}
        <div className="flex justify-between items-start mb-6">
          <div className="flex-1">
            <div className="flex items-center space-x-4 mb-3">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center">
                <Plane className="w-6 h-6 mr-3 text-blue-600" />
                Récapitulatif du Vol
              </h2>
              <span
                className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                  request.statut
                )}`}
              >
                {request.statut}
              </span>
              <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold border border-blue-200">
                {flightType}
              </span>
              {isMultiFlight && (
                <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold border border-purple-200">
                  {flightCount} vols
                </span>
              )}
            </div>

            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <div className="flex items-center">
                <Calendar className="w-4 h-4 mr-2" />
                <span>
                  Demande créée le{" "}
                  {new Date(request.createdAt).toLocaleDateString("fr-FR")}
                </span>
              </div>
              <div className="flex items-center">
                <User className="w-4 h-4 mr-2" />
                <span className="font-medium">
                  {request.prenom} {request.nom}
                </span>
              </div>

              <div className="flex items-center">
                <Users className="w-4 h-4 mr-2" />
                <div>
                  {/* Ligne 1 : Nombre total de voyageurs */}
                  <div className="font-medium">
                    {parseInt(request.vol[0].searchParams?.adults) +
                      parseInt(request.vol[0].searchParams?.children) +
                      parseInt(request.vol[0].searchParams?.children)}{" "}
                    voyageur
                    {parseInt(request.vol[0].searchParams?.adults) +
                      parseInt(request.vol[0].searchParams?.children) +
                      parseInt(request.vol[0].searchParams?.children) >
                    1
                      ? "s"
                      : ""}
                  </div>

                  {/* Ligne 2 : Détails par catégorie avec emojis ou icônes */}
                  <div className="flex flex-wrap gap-3 mt-1">
                    {request.vol[0].searchParams.adults > 0 && (
                      <div className="flex items-center text-sm text-blue-600">
                        <span className="mr-1">👤</span>
                        <span className="font-semibold">
                          {request.vol[0].searchParams.adults} adulte
                          {request.vol[0].searchParams.adults > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}

                    {request.vol[0].searchParams.children > 0 && (
                      <div className="flex items-center text-sm text-green-600">
                        <span className="mr-1">🧒</span>
                        <span className="font-semibold">
                          {request.vol[0].searchParams.children} enfant
                          {request.vol[0].searchParams.children > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}

                    {request.vol[0].searchParams.infants > 0 && (
                      <div className="flex items-center text-sm text-pink-600">
                        <span className="mr-1">👶</span>
                        <span className="font-semibold">
                          {request.vol[0].searchParams.infants} bébé
                          {request.vol[0].searchParams.infants > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-right">
            <p className="text-sm text-gray-600 mb-1">Montant total</p>
            <p className="text-2xl font-bold text-blue-600">
              {formatPrixCFA(request.montant)}
            </p>
          </div>
        </div>

        {/* Informations principales du trajet AVEC DÉTAILS DU VOL */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          {/* Détails du vol */}
          <div className="space-y-3 p-4 bg-blue-50 rounded-lg border border-blue-100 md:col-span-2">
            <div className="flex items-center text-sm text-blue-700 font-semibold">
              <Plane className="w-4 h-4 mr-2" />
              <span>Détails du vol</span>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500 mb-1">Numéro de vol</p>
                <p className="font-bold text-lg text-gray-900">
                  {request.vol[0].flightData.airline.code +
                    " " +
                    request.vol[0].flightData.airline.number}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Compagnie</p>
                <p className="font-bold text-lg text-gray-900">
                  {getAirlineName(request.vol[0].flightData.airline.code)}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Départ</p>
                <p className="font-semibold text-gray-900">
                  {request.vol[0].flightData.departure.iataCode}
                </p>
                {/* <p className="text-xs text-gray-600">
                  {request.vol[0].flightData.departure.at}
                </p> */}
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Destination</p>
                <p className="font-semibold text-gray-900">
                  {request.vol[0].flightData.arrival.iataCode}
                </p>
              </div>
            </div>
            {request.vol[0].flightData.departure.at && (
              <div className="mt-3 pt-3 border-t border-blue-200">
                <p className="text-sm text-blue-600 font-semibold">
                  Date de départ: {dateIntl(request.vol[0].flightData.departure.at)}
                </p>
              </div>
            )}
          </div>

          <div className="space-y-3 p-4 bg-green-50 rounded-lg border border-green-100">
            <div className="flex items-center text-sm text-green-700 font-semibold">
              <User className="w-4 h-4 mr-2" />
              <span>Demandeur</span>
            </div>
            <p className="font-bold text-lg text-gray-900">
              {request.fonction}
            </p>
            <p className="text-sm text-green-600">{request.matricule}</p>

            <div className="flex flex-wrap gap-1 mt-2">
              <div>
                <span className="font-semibold">Adultes:</span>{" "}
                {request.vol[0].searchParams.adults}
              </div>
              <div>
                <span className="font-semibold">Enfants:</span>{" "}
                {request.vol[0].searchParams.children}
              </div>
              <div>
                <span className="font-semibold">Bébés:</span>{" "}
                {request.vol[0].searchParams.infants}
              </div>
            </div>
          </div>

          <div className="space-y-3 p-4 bg-purple-50 rounded-lg border border-purple-100">
            <div className="flex items-center text-sm text-purple-700 font-semibold">
              <FileText className="w-4 h-4 mr-2" />
              <span>Objet du voyage</span>
            </div>
            <p className="font-bold text-lg text-gray-900">
              {request.objetVoyage}
            </p>
            <p className="text-sm text-purple-600">{request.categorie}</p>
            <div
              className={`text-xs px-2 py-1 rounded-full mt-1 inline-block ${
                request.searchParams?.travelClass === "BUSINESS"
                  ? "bg-purple-100 text-purple-700"
                  : "bg-blue-100 text-blue-700"
              }`}
            >
              {request.searchParams?.travelClass === "BUSINESS"
                ? "Classe Affaires"
                : "Classe Économique"}
            </div>
          </div>
        </div>

        {/* Motif de déplacement */}
        {request.motifDeplacement && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Motif du déplacement:</span>{" "}
              {request.motifDeplacement}
            </p>
          </div>
        )}

        {/* Bouton d'affichage des détails */}
        <div className="flex justify-center mb-6">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center transition-colors duration-200 font-medium"
          >
            {isExpanded ? (
              <>
                <ChevronDown className="w-4 h-4 mr-2" />
                Masquer les détails du vol
              </>
            ) : (
              <>
                <ChevronRight className="w-4 h-4 mr-2" />
                Afficher les détails du vol
              </>
            )}
          </button>
        </div>

        {/* Section détails expandable */}
        {isExpanded && (
          <div className="border-t border-gray-200 bg-gray-50 p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Détails des vols */}
              <div>
                <h4 className="font-bold text-xl mb-6 flex items-center text-gray-800">
                  <Plane className="w-6 h-6 mr-3 text-blue-600" />
                  Détails du Vol
                </h4>
                {renderFlightDetails()}
              </div>

              {/* Voyageurs et informations supplémentaires */}
              <div>
                <h4 className="font-bold text-xl mb-6 flex items-center text-gray-800">
                  <Users className="w-6 h-6 mr-3 text-green-600" />
                  Voyageurs{" "}
                  {request.travelers && `(${request.travelers.length})`}
                </h4>
                {renderTravelers()}

                {/* Informations supplémentaires */}
                <div className="mt-8 space-y-4">
                  <div className="p-4 bg-white rounded-lg border border-gray-200">
                    <h5 className="font-semibold text-lg mb-3 text-gray-800">
                      Paramètres de recherche
                    </h5>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="text-gray-600">Type de vol:</span>
                        <p className="font-medium">{flightType}</p>
                      </div>
                      <div>
                        <span className="text-gray-600">Classe:</span>
                        <p className="font-medium">
                          {request.searchParams?.travelClass === "BUSINESS"
                            ? "Affaires"
                            : "Économique"}
                        </p>
                      </div>
                      <div>
                        <span className="text-gray-600">Adultes:</span>
                        <p className="font-medium">
                          {request.vol[0].searchParams?.adults || 1}
                        </p>
                      </div>
                      <div>
                        <span className="text-gray-600">Enfants:</span>
                        <p className="font-medium">
                          {request.vol[0].searchParams?.children || 0}
                        </p>
                      </div>
                      <div>
                        <span className="text-gray-600">Bébés:</span>
                        <p className="font-medium">
                          {request.vol[0].searchParams?.infants || 0}
                        </p>
                      </div>
                      <div>
                        <span className="text-gray-600">Total voyageurs:</span>
                        <p className="font-medium">
                          {parseInt(request.vol[0].searchParams?.adults) +
                            parseInt(request.vol[0].searchParams?.infants) +
                            parseInt(request.vol[0].searchParams?.children)}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Récapitulatif tarifaire */}
                  <div className="p-4 bg-white rounded-lg border border-gray-200">
                    <h5 className="font-semibold text-lg mb-3 text-gray-800">
                      Récapitulatif tarifaire
                    </h5>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span>Total:</span>
                        <span className="font-bold text-lg text-blue-600">
                             {formatPrixCFA(request.montant)}
                          {/* {request.montant} {request.devise} */}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Boutons d'action du workflow */}
        <div className="flex flex-wrap gap-3 mt-8 pt-6 border-t border-gray-200">
          {request.statut === "En attente" && (
            <>
              <button
                onClick={() => handleApproveFligth(request.id)}
                className="px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center transition-colors duration-200 font-medium"
              >
                <CheckCircle className="w-4 h-4 mr-2" />
                Approuver
              </button>
              <button
                onClick={() => handleRejectFligth(request.id)}
                className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center transition-colors duration-200 font-medium"
              >
                <X className="w-4 h-4 mr-2" />
                Rejeter
              </button>
            </>
          )}

          {request.statut === "Approuvée" && (
            <>
              <button
                onClick={() => handleEditTravelers(request)}
                className="px-5 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center transition-colors duration-200 font-medium"
              >
                <Users className="w-4 h-4 mr-2" />
                Saisir voyageurs
              </button>
              <button
                onClick={() => handleEmitTicket(request.id)}
                className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center transition-colors duration-200 font-medium"
              >
                <FileText className="w-4 h-4 mr-2" />
                Émettre billet
              </button>
            </>
          )}

          {request.statut === "Billet émis" && (
            <button
              onClick={() => handleShowTicket(request)} // ← Changement ici
              className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 flex items-center transition-colors duration-200 font-medium"
            >
              <Eye className="w-4 h-4 mr-2" />
              Voir le billet
            </button>
          )}

          <button
            onClick={() => handleDelete(request.id)}
            className="px-5 py-2.5 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 flex items-center transition-colors duration-200 font-medium"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Supprimer
          </button>
        </div>
        {selectedTicket && (
          <ElectronicTicket
            request={selectedTicket.request}
            billetReference={selectedTicket.billetReference}
            onClose={() => setSelectedTicket(null)}
            onPrint={() => console.log("Billet imprimé")}
            onDownload={() => console.log("Billet téléchargé")}
          />
        )}
      </div>
    );
  };

  if (loading && requests.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-12 text-center">
        <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
        <p className="text-gray-600">Chargement des demandes...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <Plane className="w-6 h-6 mr-2 text-blue-600" />
          Demandes de billets d'avion
        </h2>
        <div className="flex space-x-3">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded-lg"
          >
            <option value="all">Tous les statuts</option>
            <option value="En attente">En attente</option>
            <option value="Approuvée">Approuvée</option>
            <option value="Rejetée">Rejetée</option>
            <option value="Billet émis">Billet émis</option>
          </select>
          <button
            onClick={loadRequests}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Actualisation...
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                Actualiser
              </>
            )}
          </button>
        </div>
      </div>

      {error && (
        <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600 font-semibold">{error}</p>
          <button
            onClick={loadRequests}
            className="mt-2 text-sm text-red-700 underline"
          >
            Réessayer
          </button>
        </div>
      )}

      {requests.length === 0 ? (
        <div className="text-center py-12">
          <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">
            {filterStatus === "all"
              ? "Aucune demande de billet"
              : `Aucune demande avec le statut "${filterStatus}"`}
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {requests.map((request) => (
            <FlightSummary
              key={request.id}
              request={request}
              getStatusColor={getStatusColor}
            />
          ))}
        </div>
      )}

      {/* Modal pour l'édition des voyageurs */}
      <TravelersModal
        isOpen={editingTravelers}
        onClose={() => setEditingTravelers(false)}
        travelersData={travelersData}
        setTravelersData={setTravelersData}
        currentRequestId={currentRequestId}
        requests={requests}
        saving={saving}
        onSave={handleSaveTravelers}
      />
    </div>
  );
};



export const TravelersModal = ({
  isOpen = false,
  onClose = () => {},
  travelersData = [],
  setTravelersData = () => {},
  currentRequestId = null,
  requests = [],
  saving = false,
  onSave = () => {},
}) => {
  // État géré par reducer
  const [state, dispatch] = useReducer(travelersReducer, {
    localTravelersData: [],
    isInitialized: false,
  });

  // État pour suivre si la sauvegarde est en cours localement
  const [localSaving, setLocalSaving] = useState(false);

  // Calculs dérivés
  const currentRequest = useMemo(() => {
    if (!requests || !Array.isArray(requests) || !currentRequestId) {
      return null;
    }
    return requests.find((r) => r && r.id === currentRequestId) || null;
  }, [currentRequestId, requests]);

  const travelersCount = useMemo(() => {
    const defaultCount = { adults: 1, children: 0, infants: 0, total: 1 };

    if (!currentRequest) return defaultCount;

    try {
      const searchParams =
        currentRequest.vol &&
        Array.isArray(currentRequest.vol) &&
        currentRequest.vol.length > 0
          ? currentRequest.vol[0].searchParams
          : currentRequest.searchParams;

      if (!searchParams) return defaultCount;

      const adults = parseInt(searchParams.adults) || 1;
      const children = parseInt(searchParams.children) || 0;
      const infants = parseInt(searchParams.infants) || 0;

      return {
        adults,
        children,
        infants,
        total: adults + children + infants,
      };
    } catch (e) {
      return defaultCount;
    }
  }, [currentRequest]);

  // Synchronisation avec les données externes - CORRIGÉ
  useEffect(() => {
    if (isOpen && currentRequest && !state.isInitialized) {
      const expectedCount = travelersCount.total;

      // Si on a déjà des données de voyageurs existantes
      if (travelersData && travelersData.length > 0) {
        // Utiliser les données existantes et compléter si nécessaire
        const existingData = [...travelersData];

        // Si on a moins de voyageurs que prévu, ajouter des voyageurs vides
        while (existingData.length < expectedCount) {
          existingData.push({
            id: existingData.length + 1,
            nom: "",
            prenom: "",
            date_naissance: "",
            numero_passeport: "",
            date_expiration_passeport: "",
            numero_siege: "",
            nationality: "", // NOUVEAU CHAMP
            birthPlace: "", // NOUVEAU CHAMP
            type:
              existingData.length < travelersCount.adults
                ? "ADULT"
                : existingData.length <
                  travelersCount.adults + travelersCount.children
                ? "CHILD"
                : "INFANT",
          });
        }

        // Si on a trop de voyageurs, couper à la taille attendue
        if (existingData.length > expectedCount) {
          existingData.length = expectedCount;
        }

        dispatch({ type: "INIT_TRAVELERS", payload: existingData });
      } else {
        // Créer de nouveaux voyageurs
        const newTravelersData = [];
        for (let i = 0; i < expectedCount; i++) {
          let passengerType = "ADULT";
          if (i >= travelersCount.adults) {
            if (i < travelersCount.adults + travelersCount.children) {
              passengerType = "CHILD";
            } else {
              passengerType = "INFANT";
            }
          }

          newTravelersData.push({
            id: i + 1,
            nom: "",
            prenom: "",
            date_naissance: "",
            numero_passeport: "",
            date_expiration_passeport: "",
            numero_siege: "",
            nationality: "", // NOUVEAU CHAMP
            birthPlace: "", // NOUVEAU CHAMP
            type: passengerType,
            passenger_index: i,
          });
        }
        dispatch({ type: "INIT_TRAVELERS", payload: newTravelersData });
      }
    }
  }, [
    isOpen,
    currentRequest,
    state.isInitialized,
    travelersCount,
    travelersData,
  ]);

  // Reset quand le modal se ferme
  useEffect(() => {
    if (!isOpen) {
      dispatch({ type: "SET_INITIALIZED", payload: false });
      setLocalSaving(false); // Réinitialiser l'état de sauvegarde
    }
  }, [isOpen]);

  // Callbacks
  const handleTravelerChange = useCallback((index, field, value) => {
    dispatch({ type: "UPDATE_TRAVELER", index, field, value });
  }, []);

  const handleSeatSelect = useCallback((travelerIndex, seatId) => {
    dispatch({ type: "SELECT_SEAT", index: travelerIndex, seatId });
  }, []);

  // CORRECTION CRITIQUE : Fonction handleSave corrigée
  const handleSave = useCallback(async () => {
    // Empêcher les clics multiples
    if (localSaving || saving) {
      console.log("Sauvegarde déjà en cours, ignore le clic");
      return;
    }

    setLocalSaving(true);

    try {
      // Validation
      const invalidTravelers = state.localTravelersData.filter(
        (traveler, index) => {
          const isInvalid =
            !traveler.nom ||
            !traveler.prenom ||
            !traveler.numero_passeport ||
            // !traveler.numero_siege ||
            !traveler.date_naissance ||
            !traveler.date_expiration_passeport;

          return isInvalid;
        }
      );

      if (invalidTravelers.length > 0) {
        toast.error(
          `${invalidTravelers.length} voyageur(s) ont des champs manquants. Veuillez remplir tous les champs obligatoires (incluant le siège).`
        );
        return;
      }

      // Préparer les données pour la sauvegarde
      const dataToSave = state.localTravelersData.map((traveler, index) => {
        // Déterminer le type de passager
        let passengerType = "ADULT";
        if (index >= travelersCount.adults) {
          if (index < travelersCount.adults + travelersCount.children) {
            passengerType = "CHILD";
          } else {
            passengerType = "INFANT";
          }
        }

        // Récupérer les informations de vol
        let flightInfo = {};
        if (currentRequest) {
          if (currentRequest.type === "multi-flights" && currentRequest.vol) {
            const vol = currentRequest.vol[0];
            const firstItinerary = vol.itineraries?.[0];
            const firstSegment = firstItinerary?.segments?.[0];
            const lastSegment =
              firstItinerary?.segments?.[firstItinerary.segments.length - 1];

            flightInfo = {
              date_depart:
                vol.searchParams?.departureDate ||
                firstSegment?.departure?.at?.split("T")[0],
              date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
              heure_depart:
                firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) ||
                "",
              heure_arrivee:
                lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
              aeroport_depart:
                firstSegment?.departure?.iataCode ||
                vol.searchParams?.originLocationCode,
              aeroport_arrivee:
                lastSegment?.arrival?.iataCode ||
                vol.searchParams?.destinationLocationCode,
              numero_vol: firstSegment?.number,
              compagnie: firstSegment?.carrierCode,
            };
          } else {
            const firstItinerary = currentRequest.itineraries?.[0];
            const firstSegment = firstItinerary?.segments?.[0];
            const lastSegment =
              firstItinerary?.segments?.[firstItinerary.segments.length - 1];

            flightInfo = {
              date_depart:
                currentRequest.searchParams?.departureDate ||
                firstSegment?.departure?.at?.split("T")[0],
              date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
              heure_depart:
                firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) ||
                "",
              heure_arrivee:
                lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
              aeroport_depart:
                currentRequest.searchParams?.originLocationCode ||
                firstSegment?.departure?.iataCode,
              aeroport_arrivee:
                currentRequest.searchParams?.destinationLocationCode ||
                lastSegment?.arrival?.iataCode,
              numero_vol: firstSegment?.number,
              compagnie: firstSegment?.carrierCode,
            };
          }
        }

        return {
          // Champs de base
          id: traveler.id,
          nom: traveler.nom,
          prenom: traveler.prenom,
          date_naissance: traveler.date_naissance,
          numero_passeport: traveler.numero_passeport,
          date_expiration_passeport: traveler.date_expiration_passeport,
          numero_siege: traveler?.numero_siege || "0",

          // NOUVEAUX CHAMPS
          nationality: traveler.nationality || "",
          birthPlace: traveler.birthPlace || "",

          // Métadonnées
          type: passengerType,
          passenger_index: index,

          // Informations de vol
          ...flightInfo,
        };
      });

      console.log("✅ Données préparées pour sauvegarde:", dataToSave);

      // CORRECTION : Sauvegarder les données ET les passer directement à onSave
      setTravelersData(dataToSave);

      // Appeler onSave avec les données directement
      await onSave(dataToSave);

      // Fermer le modal après sauvegarde réussie
      onClose();
    } catch (error) {
      console.error("❌ Erreur lors de la sauvegarde:", error);
      alert(
        "Une erreur est survenue lors de la sauvegarde. Veuillez réessayer."
      );
    } finally {
      setLocalSaving(false);
    }
  }, [
    state.localTravelersData,
    setTravelersData,
    onSave,
    onClose,
    currentRequest,
    travelersCount,
    localSaving,
    saving,
  ]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const getTravelerType = useCallback(
    (index) => {
      const defaultType = { type: "Voyageur", color: "gray", index: 1 };

      if (typeof index !== "number" || !travelersCount) return defaultType;

      if (index < travelersCount.adults) {
        return { type: "Adulte", color: "blue", index: index + 1 };
      }

      const afterAdults = index - travelersCount.adults;
      if (afterAdults < travelersCount.children) {
        return { type: "Enfant", color: "green", index: afterAdults + 1 };
      }

      const afterChildren = afterAdults - travelersCount.children;
      return { type: "Bébé", color: "pink", index: afterChildren + 1 };
    },
    [travelersCount]
  );

  // Constantes
  const colorClasses = {
    blue: { bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-500" },
    green: {
      bg: "bg-green-50",
      border: "border-green-200",
      dot: "bg-green-500",
    },
    pink: { bg: "bg-pink-50", border: "border-pink-200", dot: "bg-pink-500" },
    gray: { bg: "bg-gray-50", border: "border-gray-200", dot: "bg-gray-500" },
  };

  // Vérification pour le rendu
  const shouldRender = isOpen && currentRequestId && currentRequest;

  // Combinaison des états de sauvegarde
  const isSaving = localSaving || saving;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 items-center justify-center z-50 p-4 ${
        shouldRender ? "flex" : "hidden"
      }`}
    >
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* En-tête du modal */}
        <div className="p-6 border-b sticky top-0 bg-white z-10">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                Saisie des voyageurs et choix des sièges
              </h3>
              {currentRequest && (
                <p className="text-gray-600 mt-1">
                  Vol {currentRequest.searchParams?.originLocationCode || "---"}{" "}
                  →{" "}
                  {currentRequest.searchParams?.destinationLocationCode ||
                    "---"}
                  {currentRequest.searchParams?.departureDate &&
                    ` • ${new Date(
                      currentRequest.searchParams.departureDate
                    ).toLocaleDateString("fr-FR")}`}
                </p>
              )}
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
              aria-label="Fermer"
              disabled={isSaving}
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Résumé des voyageurs */}
          <div className="mt-3 flex items-center space-x-4 text-sm text-gray-500">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
              <span>Adultes: {travelersCount.adults}</span>
            </div>
            {travelersCount.children > 0 && (
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                <span>Enfants: {travelersCount.children}</span>
              </div>
            )}
            {travelersCount.infants > 0 && (
              <div className="flex items-center">
                <div className="w-2 h-2 bg-pink-500 rounded-full mr-2"></div>
                <span>Bébés: {travelersCount.infants}</span>
              </div>
            )}
            <div className="flex items-center ml-auto bg-gray-100 px-3 py-1 rounded-full">
              <Users className="w-4 h-4 mr-2" />
              <span className="font-medium">
                Total: {travelersCount.total} voyageurs
              </span>
            </div>
          </div>

          {/* Barre de progression */}
          <div className="mt-4">
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-500 transition-all duration-300"
                style={{
                  width: `${
                    (state.localTravelersData.filter(
                      (t) =>
                        t.nom &&
                        t.prenom &&
                        t.numero_passeport &&
                        t.numero_siege &&
                        t.date_naissance &&
                        t.date_expiration_passeport
                    ).length /
                      travelersCount.total) *
                    100
                  }%`,
                }}
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              {
                state.localTravelersData.filter(
                  (t) =>
                    t.nom &&
                    t.prenom &&
                    t.numero_passeport &&
                    t.numero_siege &&
                    t.date_naissance &&
                    t.date_expiration_passeport
                ).length
              }{" "}
              / {travelersCount.total} voyageurs complétés
            </p>
          </div>
        </div>

        {/* Contenu principal */}
        <div className="p-6 space-y-6">
          {Array.isArray(state.localTravelersData) &&
            state.localTravelersData.map((traveler, index) => {
              const travelerType = getTravelerType(index);
              const colors =
                colorClasses[travelerType.color] || colorClasses.gray;
              const isComplete =
                traveler.nom &&
                traveler.prenom &&
                traveler.numero_passeport &&
                traveler.numero_siege &&
                traveler.date_naissance &&
                traveler.date_expiration_passeport;

              return (
                <div
                  key={`traveler-${index}`}
                  className={`border rounded-lg overflow-hidden transition-all duration-200 ${
                    isComplete
                      ? "border-green-300 shadow-sm"
                      : "border-gray-200"
                  }`}
                >
                  {/* En-tête du bloc voyageur */}
                  <div
                    className={`${colors.bg} border-b ${colors.border} px-4 py-3`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div
                          className={`w-3 h-3 ${colors.dot} rounded-full mr-3`}
                        ></div>
                        <h4 className="font-bold text-gray-900">
                          {travelerType.type} {travelerType.index}
                        </h4>
                        {isComplete && (
                          <span className="ml-3 text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                            ✓ Complet
                          </span>
                        )}
                      </div>
                      {/* {traveler?.numero_siege && (
                        <div className="bg-white px-3 py-1 rounded-full border border-gray-300">
                          <span className="text-sm font-medium text-gray-700">
                            Siège: {traveler.numero_siege}
                          </span>
                        </div>
                      )} */}
                    </div>
                  </div>

                  {/* Formulaire du voyageur */}
                  <div className="p-4">
                    <TravelerForm
                      traveler={traveler || {}}
                      index={index}
                      travelerType={travelerType.type}
                      onChange={handleTravelerChange}
                      onSeatSelect={handleSeatSelect}
                      travelClass={
                        currentRequest?.searchParams?.travelClass || "ECONOMY"
                      }
                      // NOUVEAUX PROPS POUR LES CHAMPS AJOUTÉS
                      showNationality={true}
                      showBirthPlace={true}
                    />
                  </div>
                </div>
              );
            })}
        </div>

        {/* Pied de page */}
        <div className="p-6 border-t bg-gray-50 sticky bottom-0">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-600">
              <p className="font-medium">
                * Tous les champs sont obligatoires sauf nationalité et lieu de
                naissance
              </p>
              <p className="text-xs mt-1">
                Assurez-vous que les informations correspondent exactement aux
                passeports
              </p>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={handleClose}
                disabled={isSaving}
                className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium"
              >
                Annuler
              </button>
              <button
                onClick={handleSave}
                // disabled={
                //   isSaving ||
                //   state.localTravelersData.some(
                //     (t) =>
                //       !t.nom ||
                //       !t.prenom ||
                //       !t.numero_passeport ||
                //       !t.numero_siege ||
                //       !t.date_naissance ||
                //       !t.date_expiration_passeport
                //   )
                // }
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium flex items-center"
              >
                {isSaving ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    Sauvegarde en cours...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    Sauvegarder les voyageurs
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



const TravelerForm = React.memo(
  ({
    traveler,
    index,
    travelerType,
    onChange,
    onSeatSelect,
    travelClass,
    showNationality = true,
    showBirthPlace = true,
  }) => {
    const [showSeatMap, setShowSeatMap] = useState(false);

    const handleInputChange = (field, value) => {
      onChange(index, field, value);
    };

    const handleSeatSelection = (seatId) => {
       alert(seatId)
      onSeatSelect(index, seatId);
      setShowSeatMap(false);
    };

    return (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Nom */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nom *
            </label>
            <input
              type="text"
              value={traveler.nom || ""}
              onChange={(e) => handleInputChange("nom", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Nom de famille"
              required
            />
          </div>

          {/* Prénom */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Prénom *
            </label>
            <input
              type="text"
              value={traveler.prenom || ""}
              onChange={(e) => handleInputChange("prenom", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Prénom"
              required
            />
          </div>

          {/* Date de naissance */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date de naissance *
            </label>
            <input
              type="date"
              value={traveler.date_naissance || ""}
              onChange={(e) =>
                handleInputChange("date_naissance", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          {/* Numéro de passeport */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              N° Passeport *
            </label>
            <input
              type="text"
              value={traveler.numero_passeport || ""}
              onChange={(e) =>
                handleInputChange("numero_passeport", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Numéro de passeport"
              required
            />
          </div>

          {/* Date d'expiration du passeport */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Expiration passeport *
            </label>
            <input
              type="date"
              value={traveler.date_expiration_passeport || ""}
              onChange={(e) =>
                handleInputChange("date_expiration_passeport", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          {/* Sélection du siège avec plan visuel */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Siège
            </label>
            <button
              type="button"
              onClick={() => setShowSeatMap(true)}
              className={`
              w-full px-3 py-2 border rounded-lg text-left 
              flex items-center justify-between transition-all duration-200
              ${
                traveler.numero_siege
                  ? "border-green-500 bg-green-50 hover:bg-green-100"
                  : "border-gray-300 hover:bg-gray-50 hover:border-gray-400"
              }
            `}
            >
              <span className="flex items-center">
                <MapPin className="w-4 h-4 mr-2 text-gray-500" />
                <span
                  className={
                    traveler.numero_siege
                      ? "text-gray-900 font-medium"
                      : "text-gray-500"
                  }
                >
                  {traveler.numero_siege || "Sélectionner un siège"}
                </span>
              </span>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>
            {/* {!traveler.numero_siege && (
              <p className="text-xs text-red-500 mt-1">
                Siège obligatoire pour l'émission du billet
              </p>
            )} */}
          </div>

          {/* NOUVEAUX CHAMPS - NATIONALITÉ ET LIEU DE NAISSANCE (non obligatoires) */}
          {showNationality && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nationalité
              </label>
              <input
                type="text"
                value={traveler.nationality || ""}
                onChange={(e) =>
                  handleInputChange("nationality", e.target.value)
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ex: Française"
              />
            </div>
          )}

          {showBirthPlace && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Lieu de naissance
              </label>
              <input
                type="text"
                value={traveler.birthPlace || ""}
                onChange={(e) =>
                  handleInputChange("birthPlace", e.target.value)
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ex: Paris, France"
              />
            </div>
          )}
        </div>

        {/* Modal SeatMap */}
        {showSeatMap && (
          <SeatMap
            selectedSeat={traveler.numero_siege}
            onSeatSelect={handleSeatSelection}
            travelClass={travelClass}
            passengerType={travelerType}
            onClose={() => setShowSeatMap(false)}
          />
        )}
      </>
    );
  }
);


const SeatMap = ({ flightOffer, onSeatSelect }) => {
  const [seatmap, setSeatmap] = useState(null);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSeatmap();
  }, [flightOffer]);

  console.log({onSeatSelect})

  const loadSeatmap = async () => {
    // try {
    //   const response = await fetch(`${API_BASE_URL2}/amadeus/seatmap`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({ flightOffer }),
    //   });
    //   const data = await response.json();
    //   setSeatmap(data);
    // } catch (error) {
    //   console.error("Erreur chargement seatmap:", error);
    // } finally {
    //   setLoading(false);
    // }
  };

  const getSeatColor = (seat) => {
    if (selectedSeats.includes(seat.number)) return "bg-blue-500";
    if (!seat.available) return "bg-gray-400";
    if (seat.features.isPaid) return "bg-yellow-400";
    if (seat.features.hasExtraLegroom) return "bg-green-400";
    if (seat.features.isEmergencyExit) return "bg-orange-400";
    return "bg-white border-2 border-gray-300";
  };

  const getSeatIcon = (seat) => {
    if (!seat.available) return "✗";
    if (seat.features.isPaid) return "$";
    if (seat.features.hasExtraLegroom) return "+";
    return seat.number;
  };

  const toggleSeat = (seat) => {
    if (!seat.available) return;

    if (selectedSeats.includes(seat.number)) {
      setSelectedSeats(selectedSeats.filter((s) => s !== seat.number));
    } else {
      setSelectedSeats([...selectedSeats, seat.number]);
    }

    onSeatSelect(seat);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="mb-6">
        <h3 className="text-xl font-bold mb-4 flex items-center">
          <Plane className="w-6 h-6 mr-2" />
          Sélection des sièges
        </h3>

        {/* Légende */}
        <div className="flex flex-wrap gap-4 mb-4 text-sm">
          <div className="flex items-center">
            <div className="w-6 h-6 bg-white border-2 border-gray-300 rounded mr-2"></div>
            <span>Disponible</span>
          </div>
          <div className="flex items-center">
            <div className="w-6 h-6 bg-gray-400 rounded mr-2"></div>
            <span>Occupé</span>
          </div>
          <div className="flex items-center">
            <div className="w-6 h-6 bg-yellow-400 rounded mr-2"></div>
            <span>Payant</span>
          </div>
          <div className="flex items-center">
            <div className="w-6 h-6 bg-green-400 rounded mr-2"></div>
            <span>Extra legroom</span>
          </div>
          <div className="flex items-center">
            <div className="w-6 h-6 bg-orange-400 rounded mr-2"></div>
            <span>Sortie de secours</span>
          </div>
          <div className="flex items-center">
            <div className="w-6 h-6 bg-blue-500 rounded mr-2"></div>
            <span>Sélectionné</span>
          </div>
        </div>
      </div>

      {/* Plan de cabine */}
      <div className="overflow-x-auto">
        <div className="inline-block min-w-max bg-gray-100 rounded-lg p-4">
          {/* En-tête avec lettres de colonnes */}
          <div className="flex justify-center mb-2">
            <div className="w-8"></div>
            {["A", "B", "C", "", "D", "E", "F"].map((letter, idx) => (
              <div
                key={idx}
                className="w-10 h-10 flex items-center justify-center font-bold"
              >
                {letter}
              </div>
            ))}
          </div>

          {/* Rangées de sièges */}
          {seatmap?.decks[0]?.seats
            .reduce((rows, seat) => {
              const rowNumber = seat.row;
              if (!rows[rowNumber]) rows[rowNumber] = [];
              rows[rowNumber].push(seat);
              return rows;
            }, [])
            .map((row, rowIdx) => (
              <div key={rowIdx} className="flex justify-center mb-1">
                <div className="w-8 flex items-center justify-center font-bold">
                  {rowIdx + 1}
                </div>
                {row.map((seat, seatIdx) => (
                  <React.Fragment key={seat.number}>
                    {seatIdx === 3 && <div className="w-10"></div>}{" "}
                    {/* Allée */}
                    <button
                      onClick={() => toggleSeat(seat)}
                      disabled={!seat.available}
                      className={`w-10 h-10 m-0.5 rounded flex items-center justify-center text-xs font-semibold transition-all hover:scale-105 ${getSeatColor(
                        seat
                      )}`}
                      title={`Siège ${seat.number}${
                        seat.price ? ` - ${seat.price} ${seat.currency}` : ""
                      }`}
                    >
                      {getSeatIcon(seat)}
                    </button>
                  </React.Fragment>
                ))}
              </div>
            ))}
        </div>
      </div>

      {/* Sièges sélectionnés */}
      {selectedSeats.length > 0 && (
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-semibold mb-2">Sièges sélectionnés:</h4>
          <div className="flex flex-wrap gap-2">
            {selectedSeats.map((seat) => (
              <span
                key={seat}
                className="px-3 py-1 bg-blue-500 text-white rounded-full text-sm"
              >
                {seat}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};




const travelersReducer = (state, action) => {
  switch (action.type) {
    case "INIT_TRAVELERS":
      return {
        ...state,
        localTravelersData: action.payload,
        isInitialized: true,
      };
    case "UPDATE_TRAVELER":
      const updatedTravelers = [...state.localTravelersData];
      updatedTravelers[action.index] = {
        ...updatedTravelers[action.index],
        [action.field]: action.value,
      };
      return {
        ...state,
        localTravelersData: updatedTravelers,
      };
    case "SELECT_SEAT":
      const updatedTravelersWithSeat = [...state.localTravelersData];
      updatedTravelersWithSeat[action.index] = {
        ...updatedTravelersWithSeat[action.index],
        numero_siege: action.seatId,
      };
      return {
        ...state,
        localTravelersData: updatedTravelersWithSeat,
      };
    case "SET_INITIALIZED":
      return {
        ...state,
        isInitialized: action.payload,
      };
    default:
      return state;
  }
};